import { Icon } from "@me8eon/icons";
import { LinkedTickets } from "../aidwops.types";

export default function LinkedTicketsView({
    tickets,
}: {
    tickets: LinkedTickets;
}) {
    return (
        <>
            <div className="expert-queue-item-detail-card-section">
                <div className="expert-queue-item-detail-card-section-label">
                    Linked tickets
                </div>
                {tickets.length > 0 ? (
                    <div className="expert-queue-item-detail-card-section--tickets">
                        {tickets.map((ticket, index) => {
                            const systemLower =
                                ticket.system?.toLowerCase() ?? "";
                            const isJira = systemLower === "jira";
                            const isServiceNow = systemLower === "servicenow";

                            return (
                                <div key={ticket.key || index}>
                                    <div className="expert-queue-item-detail-card-section--tickets__ticket-row">
                                        <div className="expert-queue-item-detail-card-section--tickets__ticket-brand">
                                            {isJira && (
                                                <Icon
                                                    name="jira"
                                                    style={{
                                                        scale: 0.5,
                                                    }}
                                                />
                                            )}
                                            {isServiceNow && (
                                                <Icon
                                                    name="cart"
                                                    style={{
                                                        scale: 0.5,
                                                    }}
                                                />
                                            )}
                                            <span className="expert-queue-item-detail-card-section--tickets__ticket-system">
                                                {isJira
                                                    ? "JIRA"
                                                    : isServiceNow
                                                      ? "ServiceNow"
                                                      : ticket.system ||
                                                        "Ticket"}
                                            </span>
                                        </div>
                                        <span className="expert-queue-item-detail-card-section--tickets__ticket-key">
                                            {ticket.key}
                                        </span>
                                        {ticket.status && (
                                            <span className="expert-queue-item-detail-card-section--tickets__ticket-status">
                                                {ticket.status}
                                            </span>
                                        )}
                                        {ticket.url && (
                                            <a
                                                href={ticket.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="expert-queue-item-detail-card-section--tickets__ticket-open"
                                            >
                                                Open
                                                <svg
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                                    <polyline points="15 3 21 3 21 9" />
                                                    <line
                                                        x1="10"
                                                        y1="14"
                                                        x2="21"
                                                        y2="3"
                                                    />
                                                </svg>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className="expert-queue-item-detail-card-section-text">
                        No ticket yet. One is created when you approve.
                    </p>
                )}
            </div>
        </>
    );
}
